import DOOR_SUMMARY from './doorSummary.graphql'

export default DOOR_SUMMARY
